import React from 'react';

import { AssociatedRunsContext } from '@neptune/entity-common-domain';

export const useAssociatedRunsContext = () => {
  return React.useContext(AssociatedRunsContext);
};
